import styles from '../../../pages/foryou/_styles/InfoBlock.module.scss';

interface IProps {
  isMobile?: boolean;
}

const Comments = ({ isMobile }: IProps) => !isMobile ? (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="rgba(0, 0, 0, 0)"
    className={styles.commentIcon}
  >
    <path
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.002 21a10 10 0 1 0-8.889-5.414L1.003 21l5.414-1.111A9.959 9.959 0 0 0 11.002 21Z"
    />
  </svg>
) : (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.5019 18C11.3558 17.9996 13.1587 17.3931 14.6359 16.2729C16.1131 15.1528 17.1836 13.5804 17.6842 11.7954C18.1848 10.0104 18.0882 8.11064 17.4089 6.38568C16.7297 4.66072 15.5051 3.20512 13.9218 2.24071C12.3385 1.27629 10.4834 0.855946 8.63903 1.04373C6.79469 1.23151 5.0623 2.01712 3.70588 3.28084C2.34946 4.54456 1.44338 6.21708 1.12572 8.04355C0.808062 9.87001 1.09624 11.7502 1.94635 13.3977L1.00191 18L5.60418 17.0556C6.77151 17.6591 8.09751 18 9.5019 18Z"
    />
  </svg>
)

export default Comments;
